// All form field types here
//
// Valid validationTypes:
// - alphanum - > Only accept A- Z case insensitive
// - email    - > Only accept emails
// - num      - > Only accept 0- 9
// - option   - > Only allows the text denoted in the `options` prop
// - text     - > allows any alphanum and the chars !@#$%^&*()-=_+?.[]{}, tab newline
// - url      - > allows any alphanum and the chars `: / .`
const form = {
  fields: [
    // all values, other than 'type', should be either Boolean or string
    {
      type: 'header',
      label: 'Form Header',
    },
    {
      type: 'text',
      label: 'Text',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: false,
      validationType: 'text',
    },
    {
      type: 'email',
      label: 'Email',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: false,
      validationType: 'email',
    },
    {
      type: 'number',
      label: 'Number',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: false,
      validationType: 'num',
    },
    {
      type: 'textarea',
      label: 'Textarea',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: false,
      validationType: 'text',
    },
    {
      type: 'select',
      label: 'Select Options',
      required: false,
      toolTip: false,
      options: [
        { value: 'Option 1' },
        { value: 'Option 2' },
        { value: 'Option 3' },
      ],
      validationType: 'option',
    },
    {
      type: 'checkbox',
      label: 'Checkbox Options',
      required: false,
      toolTip: false,
      other: false,
      options: [
        { value: 'Option 1' },
        { value: 'Option 2' },
        { value: 'Option 3' },
      ],
      validationType: 'option',
    },
    {
      type: 'radio',
      label: 'Radio Options',
      required: false,
      toolTip: false,
      other: false,
      options: [
        { value: 'Option 1' },
        { value: 'Option 2' },
        { value: 'Option 3' },
      ],
      validationType: 'option',
    },
    {
      type: 'break',
      label: 'Break Title',
    },
    {
      type: 'date',
      label: 'Date',
      noLabel: false,
      required: false,
      toolTip: false,
      validationType: 'date',
    },
    {
      type: 'url',
      label: 'Website',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: false,
      validationType: 'url',
    },
    {
      type: 'tel',
      label: 'Phone',
      noLabel: false,
      required: false,
      toolTip: false,
      placeholder: '000-000-0000',
      validationType: 'tel',
    },
  ],
};

export { form }; // eslint-disable-line



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/field-types.js